<script>
	import { ArrowRight } from 'lucide-svelte';
</script>

<section class="mx-auto flex max-w-7xl flex-col px-4 py-12 lg:pb-8 lg:pt-20">
	<div class="mx-auto grid w-full max-w-7xl grid-cols-2 gap-3 lg:grid-cols-3 lg:gap-4">
		<div class="group col-span-1 flex w-full flex-col">
			<a
				data-sveltekit-noscroll
				href="/tours#dayTours"
				class="relative flex aspect-video items-center justify-center overflow-hidden rounded-2xl bg-gray-900 px-6 py-20 sm:px-10 md:px-12 lg:px-8"
			>
				<enhanced:img
					loading="lazy"
					class="absolute inset-0 h-full w-full object-cover"
					src="/src/lib/assets/images/private-tours.jpg"
					alt="Day Tours Tasmania"
					sizes="(min-width: 1280px) 416px, (min-width: 1024px) 33vw, 50vw"
				/>
				<div
					class="absolute inset-0 bg-foreground/30 mix-blend-multiply transition-all group-hover:bg-foreground/40"
				></div>
				<div class="relative mx-auto max-w-2xl lg:mx-0">
					<h3 class="text-center text-xl font-bold tracking-tight text-background">Day Tours</h3>
				</div>
				<div
					class="absolute bottom-4 right-4 translate-x-8 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-60"
				>
					<ArrowRight class="h-6 w-6 text-background" />
				</div>
			</a>
		</div>
		<div class="group col-span-1 flex w-full flex-col">
			<a
				data-sveltekit-noscroll
				href="/tours#bundledDayTours"
				class="relative flex aspect-video items-center justify-center overflow-hidden rounded-2xl bg-gray-900 px-6 py-20 sm:px-10 md:px-12 lg:px-8"
			>
				<enhanced:img
					loading="lazy"
					class="absolute inset-0 h-full w-full object-cover"
					src="/src/lib/assets/images/wineglass-2.jpg"
					alt="Bundled Day Tours Tasmania"
					sizes="(min-width: 1280px) 416px, (min-width: 1024px) 33vw, 50vw"
				/>
				<div
					class="absolute inset-0 bg-foreground/30 mix-blend-multiply transition-all group-hover:bg-foreground/40"
				></div>
				<div class="relative mx-auto max-w-2xl lg:mx-0">
					<h3 class="text-center text-xl font-bold text-background">Bundled Day Tours</h3>
				</div>
				<div
					class="absolute bottom-4 right-4 translate-x-8 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-60"
				>
					<ArrowRight class="h-6 w-6 text-background" />
				</div>
			</a>
		</div>
		<div class="group col-span-1 flex w-full flex-col">
			<a
				data-sveltekit-noscroll
				href="/tours#multiDayTours"
				class="relative flex aspect-video items-center justify-center overflow-hidden rounded-2xl bg-gray-900 px-6 py-20 sm:px-10 md:px-12 lg:px-8"
			>
				<enhanced:img
					loading="lazy"
					class="absolute inset-0 h-full w-full object-cover"
					src="/src/lib/assets/images/bruny-island-day-tour.jpg"
					alt="Multi-day Tours Tasmania"
					sizes="(min-width: 1280px) 416px, (min-width: 1024px) 33vw, 50vw"
				/>
				<div
					class="absolute inset-0 bg-foreground/30 mix-blend-multiply transition-all group-hover:bg-foreground/40"
				></div>
				<div class="relative mx-auto max-w-2xl lg:mx-0">
					<h3 class="text-center text-xl font-bold text-background">Multi-day Tours</h3>
				</div>
				<div
					class="absolute bottom-4 right-4 translate-x-8 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-60"
				>
					<ArrowRight class="h-6 w-6 text-background" />
				</div>
			</a>
		</div>
		<div class="group col-span-1 flex w-full flex-col">
			<a
				data-sveltekit-noscroll
				href="/private-tours"
				class="relative flex aspect-video items-center justify-center overflow-hidden rounded-2xl bg-gray-900 px-6 py-20 sm:px-10 md:px-12 lg:px-8"
			>
				<enhanced:img
					loading="lazy"
					class="absolute inset-0 h-full w-full object-cover"
					src="/src/lib/assets/images/roaming-tas.jpg"
					alt="Private Tours Tasmania"
					sizes="(min-width: 1280px) 416px, (min-width: 1024px) 33vw, 50vw"
				/>
				<div
					class="absolute inset-0 bg-foreground/30 mix-blend-multiply transition-all group-hover:bg-foreground/40"
				></div>
				<div class="relative mx-auto max-w-2xl lg:mx-0">
					<h3 class="text-center text-xl font-bold text-background">Private Tours</h3>
				</div>
				<div
					class="absolute bottom-4 right-4 translate-x-8 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-60"
				>
					<ArrowRight class="h-6 w-6 text-background" />
				</div>
			</a>
		</div>
		<div class="group col-span-1 flex w-full flex-col">
			<a
				data-sveltekit-noscroll
				href="/custom-private-tours"
				class="relative flex aspect-video items-center justify-center overflow-hidden rounded-2xl bg-gray-900 px-6 py-20 sm:px-10 md:px-12 lg:px-8"
			>
				<enhanced:img
					loading="lazy"
					class="absolute inset-0 h-full w-full object-cover"
					src="/src/lib/assets/images/partner-tours.jpg"
					alt="Private Day Tours Tasmania"
					sizes="(min-width: 1280px) 416px, (min-width: 1024px) 33vw, 50vw"
				/>
				<div
					class="absolute inset-0 bg-foreground/30 mix-blend-multiply transition-all group-hover:bg-foreground/40"
				></div>
				<div class="relative mx-auto max-w-2xl lg:mx-0">
					<h3 class="text-center text-xl font-bold text-background">Private Day Tours</h3>
				</div>
				<div
					class="absolute bottom-4 right-4 translate-x-8 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-60"
				>
					<ArrowRight class="h-6 w-6 text-background" />
				</div>
			</a>
		</div>
		<div class="group col-span-1 flex w-full flex-col">
			<a
				data-sveltekit-noscroll
				href="/curated-tasmania-experiences"
				class="relative flex aspect-video items-center justify-center overflow-hidden rounded-2xl bg-gray-900 px-6 py-20 sm:px-10 md:px-12 lg:px-8"
			>
				<enhanced:img
					loading="lazy"
					class="absolute inset-0 h-full w-full object-cover"
					src="/src/lib/assets/curated/curated-tours.jpg"
					alt="Bespoke Tasmania Experiences"
					sizes="(min-width: 1280px) 416px, (min-width: 1024px) 33vw, 50vw"
				/>
				<div
					class="absolute inset-0 bg-foreground/30 mix-blend-multiply transition-all group-hover:bg-foreground/40"
				></div>
				<div class="relative mx-auto max-w-2xl lg:mx-0">
					<h3 class="text-center text-xl font-bold text-background">Bespoke Tasmania Experiences</h3>
				</div>
				<div
					class="absolute bottom-4 right-4 translate-x-8 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-60"
				>
					<ArrowRight class="h-6 w-6 text-background" />
				</div>
			</a>
		</div>
	</div>
</section>
